import template from './defa-switch.vue.html';
import {MDCSwitch} from '@material/switch';

export const DefaSwitchComponent = {
	template,
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	
	mounted() {
		const switchControl = new MDCSwitch(this.$refs.root);
	},
	
	computed: {
		id() {
			return 'switch_'+ this._uid;
		}
	},
};